import { Card } from "@mui/material";
import React, { forwardRef, useImperativeHandle } from "react";
import MDBox from "theme/components/MDBox";
import FormSectionBuilder from "./form_section_builder";

const DataFormComponent = forwardRef(({ dataForm }, ref) => {

  function preprocessDataForm() {
    const dForm = document.querySelector(`#dataForm`);
    const formData = new FormData(dForm);
    const values = Object.fromEntries(formData.entries());

    let exludedName = "";
    let excluded = false;

    dataForm.form.form.sections.every((section) => {
      const ex = section.fields.every((field) => {
        if (!field.is_optional) {
          if (
            !formData.has(field.reference) ||
            values[field.reference]?.length <= 0
          ) {
            excluded = true;
            exludedName = `${field.display_name} (${section.title})`;
            return false;
          }
        }
        return true;
      });

      return ex;
    });

    if (excluded === true) {
      return { error: `${exludedName} is not provided.` };
    }

    return { values };
  }

  function handleSubmit() {
    if (dataForm === null) {
      return { error: "Data form not initialized. Select a campaign to proceed." };
    }

    return preprocessDataForm();
  }

  // 🔥 expose to parent
  useImperativeHandle(ref, () => ({
    submit: handleSubmit,
  }));

  return (
    <MDBox>
      {dataForm !== null && (
        <form id="dataForm">
          {dataForm.form.form.sections.map((formSection) => {
            let sect = (
              <MDBox mb={3} key={formSection.reference}>
                <Card sx={{ height: "100%", marginTop: "0px" }}>
                  <FormSectionBuilder
                    section={formSection}
                    logic={dataForm.form.form.navigation_logic}
                  />
                </Card>
              </MDBox>
            );

            if (
              formSection.reference in
              dataForm.form.form.navigation_logic.listeners
            ) {
              const listener =
                dataForm.form.form.navigation_logic.listeners[
                  formSection.reference
                ];

              const parentField = document.getElementById(
                `dff_${listener.trigger}`
              );

              if (parentField !== null) {
                let wID = `t_watcher_${listener.type}_${formSection.reference}`;

                sect = (
                  <div id={`${wID}`} style={{ display: "none" }} key={wID}>
                    {sect}
                  </div>
                );

                parentField.addEventListener("change", function () {
                  const d = document.getElementById(wID);

                  if (parentField.value !== listener.control) {
                    d.style.display = "none";
                    formSection.fields.every((fld) => {
                      const el = document.getElementById(
                        `dff_${fld.reference}`
                      );
                      if (el) el.value = null;
                      return false;
                    });
                  } else {
                    d.style.display = "block";
                  }
                });
              }
            }

            return sect;
          })}
        </form>
      )}
    </MDBox>
  );
});

export default DataFormComponent;